import { useIsFeatureFlagEnabled, useIsInAssist } from 'src/hooks/hooks';

/**
 * Returns true when the `solve_ab_test` feature flag is enabled.
 *
 * AB testing does not apply to the Assist (playbook) channel, so this
 * always returns false under `/assist/*` routes regardless of the flag.
 */
export const useIsAbTestAvailable = (): boolean => {
  const isSolveAbTestEnabled = useIsFeatureFlagEnabled('solve_ab_test');
  const isInAssist = useIsInAssist();
  return isSolveAbTestEnabled && !isInAssist;
};
